import { GraphQL } from "./GraphQL";
import StoreBase from "./lib.r3/StoreBase";

let now

class Store extends StoreBase {		//custom app store

	// ---public store attributes
	graphql
	strategyId = 0
	// projects = {}
	projectPoints = {}		//lookup list of all project points
	projectList = []
	dependencies = []
	labels = {}


	// ------------------------------------------------------------------------ init
	async init(){
		await super.init(global.config)

		this.set({		//init states
			isOnline	: false,
			isActive	: true,			//3d-interaction active
			segment		: null,
			project		: null,
			subProject	: null,
			depShow		: false,
			depMode		: 1,			//0=type, 1=nps
			years		: ['ALL'],
			selectedYear : 'ALL'
		})

		this.set = state => {
			console.log('> set', state)
			this.useState.setState(state)
		}

		this.cache.setItem('version', this.config.version)		//cache test value

		this.graphql = new GraphQL()
		await this.graphql.init(this.config.api, global.urlVars.token)

		if (!this.graphql.isInit){
			console.log('---error on initializeng graphql!')
			this.set({loadError: this.graphql.error || 'loading error'})
			return
		}

		this.user = this.graphql.user.data.user

		// get the language id from the urlvars
		// or override it with the config.ali.language
		// or take it from the user data
		this.language = global.urlVars.lang || this.config.api.language || this.user.language.iso

		console.log('user:', this.user.first_name + ' ' + this.user.last_name, '('+this.language+')', this.user)

		await this.parseLabels()

		this.set({
			user: this.user,
			language: this.language,
			labels: this.labels,
			versionString: 'Version: ' + this.config.version + ' (' + this.language + ')',
		})

		await this.parseStrategy()
	}


	// ------------------------------------------------------------------------ getLabel
	getLabel(label, alt=''){
		return this.labels[label] || alt || label
	}


	// ------------------------------------------------------------------------ parseLabels
	async parseLabels(){
		let trans = await this.graphql.getTranslations(this.language)
		if (!trans) return

		this.labels = {}
		trans.forEach(e => this.labels[e.label] = e.translation)
	}


	// ------------------------------------------------------------------------ parseStrategy
	async parseStrategy(){
		this.strategyId = global.urlVars.strategy || 1

		if (this.strategyId === '0'){
			this.strategyId = '1'
			this.test = true
		}

		console.info('load strategy data for: #' + this.strategyId, '...')

		let json = await this.graphql.getStrategy(this.strategyId)
		if (!json){
			this.set({loadError: 'error on loading strategy data for #' + this.strategyId})
			return
		}
		
		let data = JSON.parse(JSON.stringify(json))		//create working copy
		
		now = Date.now()		//current time
		console.info('parse data ...', json)
		
		this._years = {}		//year lookup list
		data._type = 'strategy'

this.info = []
		await this.parseProject(data)
console.table(this.info)	
		console.info('---strategy-data:', data, 'years:', this._years)

		this.set({strategy:data, years:this._years})
	}


	// ------------------------------------------------------------------------ parseProject
	async parseProject(data, level='', i=0, n=0, type='segment'){
		data._nps = Number(data.nps || 0)

		data._revenue = this.parseValues(data, 'values', ['Revenue','revenue'])
		data._costs = this.parseValues(data, 'values', ['Cost Saving', 'Cost Savings', 'cost-savings', 'CostSavings'])

		data._impact = data._revenue + data._costs
		data._invest = this.parseValues(data, 'investments')
		// data._resources = this.parseNumber(this.parseValues(data, 'resources'))
		data._resources = this.parseValues(data, 'resources')
		data._risks = this.parseValues(data, 'risks')

		data._time = this.parseProjectTime(data)			//0 - 100
		data._progress = this.parseProjectProgress(data)	//0 - 100

		if (data._type === 'project') this.parseYears(data)		//years filter

		if (this.test) this.parseTestData(data, i, n)

		if (data.users?.length){
			// let hasOwner = false
			data.users.forEach(u => {
				u._owner = u.userProjectRoles?.find(p => p.strategy_id === this.strategyId && p.value === 'OWNER') !== undefined

				let role = u.userProjectRoles?.find(p => p.strategy_id === this.strategyId)
				if (role){
					u._role = this.getLabel(role.value)
					if (u._role === 'OWNER') u._role = 'LEAD'

				}
			})
			data.users.sort((a, b) => a._role === 'LEAD'? -1 : 0)
		}

		// data._color = data._time < data._progress * 0.9? 1		//green
		// 	: data._time <= data._progress * 1.1? 2 			//orange
		// 	: 3													//red

		data._color = data.status === 'ahead'? 1:	//green
			data.status === 'on_track'? 2:			//orange
			data.status === 'behind'? 3:			//red
			0	//blue

// console.log('>', data._type + ':\t', level + data.name, '['+data.class+']', data._impact, data._invest, data._resources, data._time.toFixed(2), data._risks)

let info = {
	type		: data._type,
	name		: data.name,
	class		: data.class,
	impact		: data._impact,
	// impact_str	: null,
	invest		: data._invest,
	// invest_str	: null,
	resources	: data._resources,
	risks		: data._risks,
	nps			: data._nps,
	time		: data._time.toFixed(2),
	progress	: data._progress.toFixed(2),
	color		: ['blue', 'green', 'yellow', 'red'][data._color],
	status		: data.status
}
this.info.push(info)

		if (data.projects){
			for (let i in data.projects){
				data.projects[i]._type = type
				await this.parseProject(data.projects[i], level + '\t', i, n, 'project')
			}
		}

		if (data.childs?.length){
			let childs = []

			for (let i in data.childs){
				if (data.childs[i].childs?.length && this.config.mergeSubProjects){
					console.log('---merge sub projects from', data.childs[i].name+':', data.childs[i].childs)

					childs = [...childs, ...data.childs[i].childs]
					// childs.push(data.childs[i])

				}else{
					childs.push(data.childs[i])
				}
			}

			data.childs = childs
			let n = childs.length

			for (let i in childs){
				childs[i]._type = type
				await this.parseProject(childs[i], level + '\t', i, n, 'project')
			}

			childs.forEach(c => {
				c._risk_level = 0
				c._impact_level = 0
			})

			// ---sort for risk level
			childs.filter(c => c._risks).sort((a, b) => a._risks - b._risks)
				.forEach((e, i) => e._risk_level = i+1)
		
			// ---sort for impact level
			childs.filter(c => c._impact).sort((a, b) => a._impact - b._impact)
				.forEach((e, i) => e._impact_level = i+1)

			// ---sort for npsRank
			childs.sort((a, b) => a._nps - b._nps)
				.forEach((e, i) => e._npsRank = i+1)

		}

		data._impact_str = this.parseCurrency(data._impact)
		data._invest_str = this.parseCurrency(data._invest)

		// info.impact_str = data._impact_str
		// info.invest_str = data._invest_str
	}


	// ------------------------------------------------------------------------ parseTestData
	classes = [
		'standard', 'differenzierung', 'vorreiter', 'gamechanger'
	]
	parseTestData(data, i, n){
		data._time = 100 * (i+1) / n
		data._progress = 100 * (i+1) / n * (Math.random() + 0.5)
		data._nps = n === 1? 0 : Math.round(200 * i / (n-1) - 100)	//-100 - 100
		data.class = this.classes[Math.floor(Math.random() * 4)]
	
		data.effects = 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy e'
		data.benefits = 'Lorem ipsum dolor sit amet'
		data.results = 'Lorem ipsum dolor sit amet'
		data.todos = 'Lorem ipsum dolor sit amet'
		data.investment = 'Lorem ipsum dolor sit amet'
	
		data.description = data.description || 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
	}

	
	// ------------------------------------------------------------------------ parseProjectProgress
	parseProjectProgress(pData){
		if (!pData?.activities?.length) return 0
		let p = 0
		pData.activities.forEach(a => p += a.progress)
		return p / (pData.activities.length)		//average 0 - 100
	}


	// ------------------------------------------------------------------------ parseProjectTime
	parseProjectTime(pData){
		let start = pData._start = pData.start_date? new Date(pData.start_date).getTime() : 0
		let end = pData._end = pData.end_date? new Date(pData.end_date).getTime() : 0
		
		return start && end?
		start > now? 0 : end < now? 100 : 100 * (now - start) / (end - start)	//percentage value (0 - 100)
			: 0
	}


	// ------------------------------------------------------------------------ parseYears
	parseYears(pData){
		let y0, y1
		pData._years = []
		if (pData.start_date){
			y0 = pData.start_date.split('-').shift()
			if (!this._years[y0]) this._years[y0] = []
			this._years[y0].push(pData)
			pData._years.push(y0)
		}
		if (pData.end_date){
			y1 = pData.end_date.split('-').shift()
			if (y1 !== y0){
				if (!this._years[y1]) this._years[y1] = []				
				this._years[y1].push(pData)
				pData._years.push(y1)
			}
		}
	}


	// ------------------------------------------------------------------------ parseValues
	parseValues(data, type, filter){
		let value = 0
		// data.values?.forEach(v => console.log(type, v.type))
		let values = filter? data[type]?.filter(v => filter.includes(v.type)) : data[type]

		values?.forEach(v => {
			v.values.forEach(e => value += e.value)
		})
		data.childs?.forEach(c => {
			value += this.parseValues(c, type, filter)
		})
		data.projects?.forEach(c => {
			value += this.parseValues(c, type, filter)
		})
		return value
	}


	// ------------------------------------------------------------------------ parseCurrency
	parseCurrency(value){
		let lang = this.language === 'de'? 'en-DE' : 'en-US'

		let euro = Intl.NumberFormat(lang);

		// value = Math.round(value / 1000) * 1000
		value = Math.round(value)
		return 'k€ ' + euro.format(value)
	}

}

export default new Store()
